module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticStyle: {
      "max-width": "500px",
      "min-width": "100px",
      "margin": "0 0"
    },
    attrs: {
      "name": "ChangeUserInfo"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tryChangeInfo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "divTable"
  }, [_c('div', {
    staticClass: "divTableBody"
  }, [_c('div', {
    staticClass: "divTableRow",
    staticStyle: {
      "line-height": "40px"
    }
  }, [_c('div', {
    staticClass: "divRowLabel"
  }, [_vm._v("Username ")]), _vm._v(" "), _c('div', {
    staticClass: "divRowContent section form-input-validate",
    staticStyle: {
      "min-width": "100%",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeUserName),
      expression: "changeUserName"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "changeusername",
      "required": "required"
    },
    domProps: {
      "value": (_vm.changeUserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeUserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divTableRow",
    staticStyle: {
      "line-height": "40px"
    }
  }, [_c('div', {
    staticClass: "divRowLabel"
  }, [_vm._v("Display name ")]), _vm._v(" "), _c('div', {
    staticClass: "divRowContent section form-input-validate",
    staticStyle: {
      "min-width": "100%",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeDisplayName),
      expression: "changeDisplayName"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "changedisplayname"
    },
    domProps: {
      "value": (_vm.changeDisplayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeDisplayName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divTableRow",
    staticStyle: {
      "line-height": "40px"
    }
  }, [_c('div', {
    staticClass: "divRowLabel"
  }, [_vm._v("Email ")]), _vm._v(" "), _c('div', {
    staticClass: "divRowContent section form-input-validate",
    staticStyle: {
      "min-width": "100%",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeEmail),
      expression: "changeEmail"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "changedemail"
    },
    domProps: {
      "value": (_vm.changeEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "divTableRow",
    staticStyle: {
      "line-height": "40px"
    }
  }, [_c('div', {
    staticClass: "divRowLabel"
  }, [_vm._v("Enter password")]), _vm._v(" "), _c('div', {
    staticClass: "divRowContent section form-input-validate",
    staticStyle: {
      "min-width": "100%",
      "vertical-align": "middle"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changePassword),
      expression: "changePassword"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "password",
      "name": "changepassword",
      "required": "required"
    },
    domProps: {
      "value": (_vm.changePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changePassword = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "section btn __l __block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.changeResult != '') ? _c('p', [_vm._v(_vm._s(_vm.changeResult))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b532252","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/UserChangeInfoPage.vue
// module id = 357
// module chunks = 1